import { isFeatureFlagEnabled } from 'src/store/feature-flags/feature-flags.utils';

export const featureFlagsStateSelector = (state) => state.featureFlags || {};

export const featureFlagsReadySelector = (state) =>
    featureFlagsStateSelector(state).ready === true;

export const featureFlagsLoadingSelector = (state) =>
    featureFlagsStateSelector(state).loading === true;

export const featureFlagValuesSelector = (state) =>
    featureFlagsStateSelector(state).values || {};

export const featureFlagsErrorSelector = (state) =>
    featureFlagsStateSelector(state).error || '';

/**
 * @param {object} state
 * @param {string|undefined|null} flagKey
 * @returns {boolean}
 */
export const isFeatureEnabledSelector = (state, flagKey) =>
    isFeatureFlagEnabled(featureFlagValuesSelector(state), flagKey);
